module.exports = __webpack_public_path__ + "assets/img/FormTeam.3c7c5b85.png";